<template>
	<div class="packageSearch">
		<back-to :url="packageTour" :query="type"></back-to>
		<!-- 搜索 -->
		<section class="packageSearch_con">
			<div class="packageSearch_con-inp">
				<span class="packageSearch_con-inps">
					<input type="text" class="packageSearch_con__input" v-model="keyWord" placeholder="景点、关键词、目的地"
						@keyup.13="onSearch" />
					<img class="packageSearch_con-icon" @click="onSearch"
						src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/index-seach.png" alt="">
				</span>
			</div>
			<div class="packageSearch_con-screen">
				<van-dropdown-menu active-color="#ff8a00" :class="dropdownmenu">
					<van-dropdown-item :title="sortIndex === '' ?'推荐顺序':sort[sortIndex].text"
						class="packageSearch_con-screen1" ref="sort">
						<h2 @click="sortIndex = '',$refs.sort.toggle()">推荐顺序</h2>
						<ul>
							<li v-for="(item,index) in sort" @click="sortIndex = index,$refs.sort.toggle()">
								<p>{{item.text}}</p>
								<img v-if="sortIndex == index"
									src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/seachlist-ok.png" alt="">
							</li>
						</ul>
					</van-dropdown-item>
					<van-dropdown-item :title="cityIndex === '' ?'出发地':startCityList[cityIndex].Name"
						class="packageSearch_con-screen2" ref="startCity">
						<h2 @click="cityChange">出发地</h2>
						<ul>
							<li v-for="(item,index) in startCityList"
								@click="cityIndex = index,$refs.startCity.toggle(),onSearch()"
								:style="cityIndex === index?'color:#ff8a00':''">
								<p>{{item.Name}}</p>
							</li>
							<li @click="$router.push({path: '/origin',query:{type:type}})">
								<p>更多...</p>
							</li>
						</ul>
					</van-dropdown-item>
					<van-dropdown-item :title="purposeIndex === '' ?'目的地': desCurren[purposeIndex].Name"
						class="packageSearch_con-screen2" ref="purposeCity">
						<h2 @click="purposeChange">目的地</h2>
						<ul>
							<li v-for="(item,index) in desCurren"
								@click="disArr = item,purposeIndex = index,disArrIndex=0,$refs.purposeCity.toggle(),onSearch()"
								:style="purposeIndex === index?'color:#ff8a00':''">
								<p>{{item.Name}}</p>
							</li>
							<li @click="$router.push({path: '/more',query:{type:type}})">
								<p>更多...</p>
							</li>
						</ul>
					</van-dropdown-item>
					<van-dropdown-item title="全部筛选" ref="all">
						<div class="packageSearch_con-screen1">
							<h2>推荐顺序</h2>
							<ul>
								<li v-for="(item,index) in sort" @click="sortIndex = index">
									<p>{{item.text}}</p>
									<img v-if="sortIndex == index"
										src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/seachlist-ok.png" alt="">
								</li>
							</ul>
						</div>
						<div class="packageSearch_con-screen2">
							<h2>出发地</h2>
							<ul>
								<li v-for="(item,index) in startCityList" @click="cityIndex = index"
									:style="cityIndex === index?'color:#ff8a00':''">
									<p>{{item.Name}}</p>
								</li>
								<li @click="$router.push({path: '/origin',query:{type:type}})">
									<p>更多...</p>
								</li>
							</ul>
						</div>
						<div class="packageSearch_con-screen2">
							<h2>目的地</h2>
							<ul>
								<li v-for="(item,index) in desCurren" @click="disArr = item,purposeIndex = index,disArrIndex = 0"
									:style="purposeIndex === index?'color:#ff8a00':''">
									<p>{{item.Name}}</p>
								</li>
								<li @click="$router.push({path: '/more',query:{type:type}})">
									<p>更多...</p>
								</li>
							</ul>
						</div>
						<div class="packageSearch_con_but">
							<span @click="reset">重置</span>
							<span @click="sure">确定</span>
						</div>
					</van-dropdown-item>
				</van-dropdown-menu>
			</div>
			<div class="packageSearch_con-ollapse" v-if="disArr != null">
				<div :class="unfold?'con-ollapse con-ollapse-c':'con-ollapse'">
					<span class="con-ollapse1">{{disArr.Name}} : </span>
					<span class="con-ollapse2">
						<p v-for="(item, index) in disArr.City" :class="disArrIndex == index?'con-ollapse2a':''"
							@click="disArrIndex=index,unfold=false,onSearch()">
							{{item.Name}}
						</p>
						<font @click="unfold = !unfold">
							<img :src="unfold?'https://sweetour-pic.obs.myhwclouds.com/sweetmini/line-up.png':'https://sweetour-pic.obs.myhwclouds.com/sweetmini/line-dwon.png'"
								alt="">
						</font>
					</span>

				</div>
			</div>
		</section>

		<section :class="disArr != null ?'packageSearch_lists':'packageSearch_list'">
			<List :tab_menu_array_index="1" :searchShow="true" :keyWord="keyWord" ref="changList"></List>
		</section>
	</div>
</template>

<script>
	import List from '@/components/List.vue'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'packageTour',
		components: {
			BackTo,
			List
		},
		data() {
			return {
				packageTour: '/packageTour',
				activeNames: ['1'],
				dropdownmenu: 'con-screen_menu',
				type: 1,
				keyWord: '',
				sortIndex: '',
				cityIndex: '',
				purposeIndex: '',
				disArr: null,
				unfold: false,
				disArrIndex: 0,
				// 排序
				sort: [{
						text: '推荐',
						value: 1
					},
					{
						text: '销量优先',
						value: 2
					},
					{
						text: '价格由高到低',
						value: 3
					},
					{
						text: '价格由底到高',
						value: 4
					},
				],
				// 出发地
				startCityList: [{
					Name: '沈阳',
					Id: '3087'
				}, {
					Name: '大连',
					Id: '3088'
				}, {
					Name: '哈尔滨',
					Id: '3110'
				}, {
					Name: '长春',
					Id: '3101'
				}],
				desCurren: []
			}
		},
		watch: {
			sortIndex() {
				this.shaixuan()
			},
			cityIndex() {
				this.shaixuan()
			},
			purposeIndex() {
				this.shaixuan()
			}

		},
		created() {
			this.type = this.$route.query.type
		},
		mounted() {
			this.getPath()
		},
		methods: {
			getList() {
				if (this.type == 2 && this.purposeIndex !== '') {
					this.keyWord = this.disArr.City[this.disArrIndex].Name
				}
				this.$nextTick(() => {
					if (this.type == 2) {
						this.$refs.changList.tourType = true
					}
					if (this.$route.query.cityData) {
						this.startCityList.unshift(this.$route.query.cityData)
						this.cityIndex = 0
						this.$refs.changList.startCityId = this.$route.query.cityData.Id
					}
					if (this.type == 1) {
						if (this.disArr != null && this.purposeIndex !== '') {
							this.$refs.changList.endCityId = Number(this.disArr.City[this.disArrIndex].Id)
						}
					}
					this.$refs.changList.page = 1
					this.$refs.changList.connect_ProductList()
				});
			},
			shaixuan() {
				if (this.sortIndex !== '' && this.cityIndex === '' && this.purposeIndex === '') {
					this.dropdownmenu = 'con-screen_menu menuAc menuAc4'
				} else if (this.sortIndex === '' && this.cityIndex !== '' && this.purposeIndex === '') {
					this.dropdownmenu = 'con-screen_menu menuAc2 menuAc4'
				} else if (this.sortIndex === '' && this.cityIndex === '' && this.purposeIndex !== '') {
					this.dropdownmenu = 'con-screen_menu menuAc3 menuAc4'
				} else if (this.sortIndex !== '' && this.cityIndex !== '' && this.purposeIndex !== '') {
					this.dropdownmenu = 'con-screen_menu menuAc menuAc2 menuAc3 menuAc4'
				} else if (this.sortIndex !== '' && this.cityIndex !== '' && this.purposeIndex === '') {
					this.dropdownmenu = 'con-screen_menu menuAc menuAc2 menuAc4'
				} else if (this.sortIndex !== '' && this.cityIndex === '' && this.purposeIndex !== '') {
					this.dropdownmenu = 'con-screen_menu menuAc menuAc3 menuAc4'
				} else if (this.sortIndex === '' && this.cityIndex !== '' && this.purposeIndex !== '') {
					this.dropdownmenu = 'con-screen_menu menuAc2 menuAc3 menuAc4'
				} else if (this.sortIndex === '' && this.cityIndex === '' && this.purposeIndex === '') {
					this.dropdownmenu = 'con-screen_menu'
				}
			},
			onSearch() {
				if (this.type == 2 && this.purposeIndex !== '') {
					this.keyWord = this.disArr.City[this.disArrIndex].Name
				}
				this.$nextTick(() => {
					window.scrollTo(0, 0)
					if (this.cityIndex !== '') {
						this.$refs.changList.startCityId = Number(this.startCityList[this.cityIndex].Id)
					}
					if (this.type == 1) {
						if (this.disArr != null && this.purposeIndex !== '') {
							this.$refs.changList.endCityId = Number(this.disArr.City[this.disArrIndex].Id)
						}
					}

					this.$refs.changList.loading = false
					this.$refs.changList.finished = false
					this.$refs.changList.page = 1
					this.$refs.changList.connect_ProductList(true)
				});
			},
			cityChange() {
				this.cityIndex = ''
				this.$refs.startCity.toggle()
				this.$nextTick(() => {
					window.scrollTo(0, 0)
					this.$refs.changList.startCityId = 0
					this.$refs.changList.loading = false
					this.$refs.changList.finished = false
					this.$refs.changList.page = 1
					this.$refs.changList.connect_ProductList(true)
				});
			},
			purposeChange() {
				this.disArr = null
				this.purposeIndex = ''
				this.$refs.purposeCity.toggle()
				this.$nextTick(() => {
					window.scrollTo(0, 0)
					this.$refs.changList.endCityId = 0
					this.$refs.changList.loading = false
					this.$refs.changList.finished = false
					this.$refs.changList.page = 1
					this.$refs.changList.connect_ProductList(true)
				});
			},
			reset() {
				this.keyWord = ''
				this.sortIndex = ''
				this.cityIndex = ''
				this.purposeIndex = ''
				this.disArr = null
				this.$refs.all.toggle()
				this.$nextTick(() => {
					window.scrollTo(0, 0)
					this.$refs.changList.startCityId = 0
					this.$refs.changList.endCityId = 0
					this.$refs.changList.loading = false
					this.$refs.changList.finished = false
					this.$refs.changList.page = 1
					this.$refs.changList.connect_ProductList(true)
				});
			},
			sure() {
				this.$refs.all.toggle()
				this.onSearch()
			},
			// 获取目的地
			getPath() {
				var data = {
					State: this.type == 1 ? 0 : 1, // 0国内 1国外
					Count: 0 // 多少条
				}
				this.$post(
					this.$apiWebsiteSweet + '/api/GetGTLine', data
				).then(res => {
					if (this.type == 1) {
						if (this.$route.query.disArr) {
							var purposeIndex = res.GN.findIndex(item => item.Id == this.$route.query.disArr.Id)
							this.desCurren = res.GN.slice(purposeIndex, purposeIndex + 7)
							this.purposeIndex = 0
							this.disArr = this.$route.query.disArr
							if(this.$route.query.disArrIndex){
								this.disArrIndex = this.$route.query.disArrIndex
							}else{
								this.disArrIndex = 0
							}
						} else {
							this.desCurren = res.GN.slice(1, 8)
						}
					} else {
						this.desCurren = res.GW
						if (this.$route.query.disArr) {
							if (this.$route.query.disArr.City === undefined) {
								this.purposeIndex = 0
								this.disArrIndex = this.desCurren[0].City.findIndex(item => item.Id == this.$route
									.query.disArr.Id)
								this.disArr = this.desCurren[0]
							} else {
								this.purposeIndex = this.desCurren.findIndex(item => item.Id == this.$route.query
									.disArr.Id)
								this.disArr = this.$route.query.disArr
								this.disArrIndex = this.$route.query.disArrIndex
							}
						}
					}
					this.getList()
				})
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
		}
	}
</script>

<style>
	.packageSearch_con {
		width: 100%;
		background: #fff;
		top: @nav-bar-height;
		position: fixed;
		z-index: 99;
	}

	.packageSearch_con-inp {
		width: 100%;
		height: 80px;
		padding: 0 30px 20px;
		box-sizing: border-box;
	}

	.packageSearch_con-inps {
		border: 1px #ff6d00 solid;
		height: 70px;
		border-radius: 36px;
		display: flex;
		padding: 0 36px;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
	}

	.packageSearch_con-icon {
		width: 28px;
		height: 28px;
	}

	.packageSearch_con__input {
		font-size: 26px;
		flex: 1;
		border: 0;
	}

	.packageSearch_con-screen {
		width: 100%;
	}

	.con-screen_menu {
		color: #666;
	}

	.menuAc .van-dropdown-menu__item:nth-child(1) .van-ellipsis {
		color: #ff8a00;
	}

	.menuAc .van-dropdown-menu__item:nth-child(1) .van-dropdown-menu__title::after {
		border-color: transparent transparent #ff8a00 #ff8a00;
	}

	.menuAc2 .van-dropdown-menu__item:nth-child(2) .van-ellipsis {
		color: #ff8a00;
	}

	.menuAc2 .van-dropdown-menu__item:nth-child(2) .van-dropdown-menu__title::after {
		border-color: transparent transparent #ff8a00 #ff8a00;
	}

	.menuAc3 .van-dropdown-menu__item:nth-child(3) .van-ellipsis {
		color: #ff8a00;
	}

	.menuAc3 .van-dropdown-menu__item:nth-child(3) .van-dropdown-menu__title::after {
		border-color: transparent transparent #ff8a00 #ff8a00;
	}

	.menuAc4 .van-dropdown-menu__item:nth-child(4) .van-ellipsis {
		color: #ff8a00;
	}

	.menuAc4 .van-dropdown-menu__item:nth-child(4) .van-dropdown-menu__title::after {
		border-color: transparent transparent #ff8a00 #ff8a00;
	}

	.con-screen_menu .van-dropdown-menu__title {
		font-size: 28px;
	}

	.packageSearch_con-screen .van-dropdown-menu__bar {
		box-shadow: none;
		height: 70px
	}

	.packageSearch_con-screen1 li {
		height: 80px;
		padding: 0 30px;
		border-bottom: 1px solid #efefef;
		font-size: 28px;
		color: #000;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.packageSearch_con-screen1 img {
		width: 23px;
		height: 19px;
	}

	.packageSearch_con-screen2 {
		margin-top: 10px;
	}

	.packageSearch_con-screen2 ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		width: 100%;
		padding: 20px 30px;
		box-sizing: border-box;
	}

	.packageSearch_con-screen2 li {
		height: 66px;
		line-height: 66px;
		text-align: center;
		width: 216px;
		border-radius: 10px;
		background: #efefef;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		box-sizing: border-box;
		margin-bottom: 20px;
		color: #000;
	}

	.packageSearch_con-screen2 li:last-child:nth-child(3n-1) {
		margin-right: 237px
	}

	.packageSearch_con-screen1 h2,
	.packageSearch_con-screen2 h2 {
		height: 60px;
		line-height: 60px;
		color: #000;
		padding: 0 30px;
		font-weight: bold;
		font-size: 28px;
	}

	.packageSearch_con_but {
		width: 100%;
		box-sizing: border-box;
		padding: 30px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.packageSearch_con_but span:first-child {
		border: 1px solid #666;
		box-sizing: border-box;
	}

	.packageSearch_con_but span:last-child {
		background: #ff8a00;
		color: #fff;
	}

	.packageSearch_con_but span {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 66px;
		width: 300px;
		font-size: 30px;
		border-radius: 200px;
		line-height: 64px;
	}

	.packageSearch_list {
		margin-top: 155px;
	}

	.packageSearch_lists {
		margin-top: 240px;
	}

	.packageSearch_con-ollapse {
		width: 100%;
		padding: 0 30px;
		box-sizing: border-box;
	}

	.con-ollapse {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		border-top: 1px solid #efefef;
		padding-top: 20px;
		height: 60px;
		overflow: hidden;
		position: relative;
	}

	.con-ollapse-c {
		height: auto;
	}

	.con-ollapse1 {
		width: 100px;
		font-size: 28px;
	}

	.con-ollapse2 {
		width: 560px;
		flex-wrap: wrap;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.con-ollapse2 p {
		margin-left: 20px;
		height: 43px;
		line-height: 43px;
		padding: 0 20px;
		background: #f7f7f7;
		border-radius: 200px;
		font-size: 28px;
		color: #333;
		margin-bottom: 20px;
	}

	.con-ollapse2a {
		background: #ff8a00 !important;
		color: #fff !important;
	}

	.con-ollapse2 font {
		position: absolute;
		bottom: 40px;
		right: 0;
		width: 20px;
	}

	.con-ollapse2 img {
		height: 10px;
		width: 17px;
		margin-left: auto;
	}
</style>
